import { routes } from "frontend/api/application";
import { requestGenericSettings } from "frontend/api/application/settings/request-generic-settings";
import { ScheduleRaw } from "frontend/interfaces/schedule";

export const api = requestGenericSettings<ScheduleRaw>({
  endpoints: {
    indexEndpoint: routes.paths.frontend_settings_schedules_path,
    showEndpoint: routes.paths.frontend_settings_schedule_path,
  },
});
